const FounderViewCard = ({ element, handleOpenDrawer }) => {
    return (
        <div
            className={`bg-white rounded-lg shadow-lg p-6 flex flex-col items-center justify-center h-full w-full`}
        >
            <div className="mb-4">
                <div className="w-[12vh] h-[12vh] bg-gray-100 rounded-full flex items-center justify-center">
                    <img src="/images/UserPlus.svg" alt="User Plus" className="w-[9vh] h-[9vh]" />
                </div>
            </div>
            <div className="text-[2vh] text-center mb-6 font-medium">{element.INSTITUTE_LEADER_DESIGNATION}</div>
            <button
                onClick={() => handleOpenDrawer()}
                className="w-[70%] py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-[2vh] font-medium"
                style={{ color: "#fff" }}
                type="button"
            >
                Add Details
            </button>
        </div>
    );
}

export default FounderViewCard;